import { Column, Entity, Index, JoinColumn, ManyToOne } from 'typeorm';
import { BaseEntity } from './base.entity';
import { ClientEntity } from './client.entity';

@Index('fk_client__id', ['fkClientId'], {})
@Index('UK_client_sales_client_date_deleted', ['fkClientId', 'date'], {
	unique: true,
})
@Entity('client_sales')
export class ClientSalesEntity extends BaseEntity {
	@Column('int', { name: 'fk_client__id', unsigned: true })
	public fkClientId!: number;

	@Column('int', { name: 'soldUnits', nullable: true })
	public soldUnits!: number | null;

	@Column('decimal', {
		name: 'revenue',
		nullable: true,
		precision: 13,
		scale: 2,
	})
	public revenue!: string | null;

	@Column('int', { name: 'uniqueItems', nullable: true })
	public uniqueItems!: number | null;

	@Column('date', { name: 'date', nullable: true })
	public date!: string | null;

	@Column('decimal', {
		name: 'totalGPAggregate',
		nullable: true,
		precision: 13,
		scale: 2,
	})
	public totalGpAggregate!: string | null;

	@Column('decimal', {
		name: 'totalGPMargin',
		nullable: true,
		precision: 13,
		scale: 2,
	})
	public totalGpMargin!: string | null;

	@ManyToOne(() => ClientEntity, (client) => client.clientSales, {
		onDelete: 'RESTRICT',
		onUpdate: 'RESTRICT',
	})
	@JoinColumn([{ name: 'fk_client__id', referencedColumnName: 'id' }])
	public fkClient!: ClientEntity;
}
